import { render, staticRenderFns } from "./SideCategory.vue?vue&type=template&id=b2a9a4d0&"
import script from "./SideCategory.vue?vue&type=script&lang=js&"
export * from "./SideCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports